import { TableCell } from '@mui/material';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { parseLocaleCode } from '../../../util/locale-code';

export default class CountryCell extends PureComponent {
  static propTypes = {
    row: PropTypes.object.isRequired
  };

  render() {
    const { code } = this.props.row;
    const { country } = parseLocaleCode(code);

    return <TableCell>{country ? `${country.emoji} ${country.name}` : 'N/A'}</TableCell>;
  }
}
